import React from 'react';
import {Modal} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {isRTL} from "../../helpers/i18n";
import useScreenSize from "../../helpers/hooks/useScreenSize";

const CustomModal = (props) => {
    const { open, onClose, title, footer, children, ...rest } = props;
    const {isMobile} = useScreenSize()

    return (
        <Modal open={open}
               onCancel={onClose}
               title={title ?? null}
               footer={footer ?? null}
               closeIcon={<FontAwesomeIcon icon={light('xmark')}/>}
               centered
               style={{direction: isRTL() ? 'rtl' : 'ltr', ...rest?.style}}
               styles={isMobile ? {wrapper: {height: '100%'}, body: {height: '100%'}} : {}}
               {...rest}
        >
            {children}
        </Modal>
    );
};

export default CustomModal;